<template>
    <a-modal title="填写意见"
             :width="1300"
             :visible="visible"
             @ok="submit"
             :confirmLoading="modalLoading"
             @cancel="$emit('cancel')">
      <a-form :form="form">
        <a-form-item>
          <a-textarea v-decorator="[
                                    'content',
                                    {rules: [{ required: true, message: '请填写意见' },
                                    { pattern: '^.{0,200}$', message: '请输入长度为0-200位的字符' }]}
                                ]" placeholder='意见'
                      :rows="4" />
        </a-form-item>
      </a-form>
<!--      <audit-comment v-if="ifWF && ifWF == '1'" :xwfState="xwfState"/>-->
    </a-modal>
</template>

<script>
import { WorkflowEvent } from '@/components/workflow/WorkflowEvent'
import qs from 'qs'
export default {
  name: 'expertView',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      info: {},
      ifWF: '',
      xwfState: {},
      routes: [],
      record: {},
      modalLoading: false,
      state: true,
      routesSelect: {}
    }
  },
  methods: {
    submit () {
      const that = this
      that.form.validateFields((err, values) => {
        if (err) {
          return
        }
        var signParams = {
          actInsId: that.xwfState.actInsId,
          caseId: that.xwfState.caseId,
          caseTypeId: that.xwfState.caseTypeId,
          commentTypeId: that.xwfState.commentTypeId,
          content: values.content,
          procInsId: that.xwfState.procInsId
        }
        that.modalLoading = true
        that.$http.post('/api/1/workflow/comment/save.json', qs.stringify(signParams)).then(function (resp) {
          // 保存完毕后，清空内容
          // that.signParams.content = ''
          if (resp.code !== 200) {
            that.$message.error('提交意见失败')
            return
          }
          var item = {}
          if (that.state) {
            var ts = that.routes.filter(e => e.name === '审核不通过' || e.name === '面试不通过')
            item = {
              actInsId: that.xwfState.actInsId,
              routeId: ts[0].id
            }
            that.nextAction(item)
          } else {
            item = {
              actInsId: that.xwfState.actInsId,
              routeId: that.routesSelect.routeId,
              userIds: that.routesSelect.users[0].id
            }
            that.nextAction(item)
          }
          that.addAuditComment(that.record, signParams.content)
          that.modalLoading = false
          that.$message.success('提交意见成功')
          that.$emit('success')
        })
      })
    },
    addAuditComment (record, content) {
      const that = this
      let data = {
        expertInfoId: record.id,
        expertState: record.state,
        content: content
      }
      that.$http.post('/api/1/expertmain/expertInfo/add_auditComment.json', qs.parse(data)).then(function (resp) {
      })
    },
    nextAction (signParams) {
      const that = this
      that.$http.post('/api/1/workflow/next_action.json', qs.stringify(signParams)).then(function (resp) {
        // 保存完毕后，清空内容
        that.form.resetFields()
      })
    },
    onFetchData (ifWF, xwfState, routes, record, state, routesSelect) {
      const that = this
      that.ifWF = ifWF
      that.xwfState = xwfState
      that.routes = routes
      that.record = record
      that.state = state
      that.routesSelect = routesSelect
    }
  }
}
</script>

<style scoped>
</style>
